var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "43px",
    height: "43px",
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-color",
    fillRule: "evenodd",
    strokeWidth: "4px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M79.120,71.552 C79.150,71.424 79.192,71.301 79.217,71.171 C80.797,65.154 81.858,54.340 81.858,41.920 C81.858,29.499 80.797,18.685 79.217,12.668 C79.192,12.538 79.150,12.415 79.120,12.285 C79.069,12.101 79.022,11.874 78.970,11.699 L78.970,11.805 C78.000,8.451 75.378,5.836 72.021,4.877 L72.158,4.877 C71.929,4.810 71.636,4.749 71.390,4.683 C71.344,4.672 71.301,4.657 71.255,4.647 C65.251,3.059 54.402,1.989 41.936,1.989 C29.470,1.989 18.621,3.059 12.617,4.647 C12.572,4.657 12.529,4.672 12.484,4.682 C12.237,4.747 11.944,4.810 11.714,4.877 L11.852,4.877 C8.486,5.840 5.857,8.466 4.894,11.833 L4.894,11.699 C4.828,11.922 4.769,12.204 4.704,12.442 C4.692,12.500 4.673,12.555 4.661,12.613 C3.073,18.619 2.005,29.462 2.005,41.920 C2.005,54.377 3.073,65.220 4.661,71.226 C4.673,71.284 4.692,71.341 4.704,71.397 C4.769,71.635 4.828,71.917 4.894,72.140 L4.894,72.006 C5.861,75.384 8.504,78.020 11.888,78.973 L11.714,78.973 C17.502,80.691 28.861,81.861 41.936,81.861 C55.011,81.861 66.370,80.691 72.158,78.973 L71.985,78.973 C75.360,78.022 77.997,75.399 78.970,72.034 L78.970,72.140 C79.022,71.965 79.069,71.739 79.120,71.552 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxShape);
export default __webpack_public_path__ + "static/media/box-shape.b194417f.svg";
export { ForwardRef as ReactComponent };